export const checkValue = (value, min, max) => {
  if (+value < min) {
    return min.toString();
  }
  if (+value > max) {
    return max.toString();
  }
  return value;
};
export const roundValue = (value, precision) => (+value).toFixed(precision);
export const integerLength = number => Math.ceil(Math.log10(+number + 1));
export const validate = value => {
  var _exec;
  return (_exec = /-?[0-9]*[.,]?[0-9]*/.exec(value)) == null ? void 0 : _exec[0].replace(',', '.');
};